
import axios from 'axios';
import EnvService from '@/services/environment/EnvService';

export default class PlayoutService {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  async getVideoData(videoId: string, playerId: string): Promise<any> {
       
    const url = EnvService.getEnvVarsJoined([
      'VUE_APP_MOVINGIMAGE_PLAYOUT_BASE_URL'
    ]) + `${playerId}/video/${videoId}`;

    const res = await axios.get(url, {
    });

    if(res.data.videoSources === undefined) {
      this.throwUnexpectedDataError(url, res.data);
    }
    return res.data;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  private throwUnexpectedDataError(url: string, data: any) {
    throw new Error(`Received unexpected data from request to ${url}: ${data}`);
  }
}